<template>
  <el-dialog 
    :title="openType === 'add' ? '新增文章页面' : '编辑文章页面'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="100%"
    fullscreen
    style="margin-left:200px;"
    :modal="false"
    custom-class="customModal">
    
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="title" class="formItemFill" label="标题">
            <el-input v-model="formValue.title" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="title_color" class="formItemFill title_color" label="标题颜色" >
            <el-color-picker v-model="formValue.title_color" style="width:100%;text-align:left;margin-top: 0.8vw"></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="文章分类" prop="article_category_id" class="formItemFill">
            <el-select v-model="formValue.article_category_id" placeholder="请选择" size="small" style="width: 100%;">
              <el-option
                v-for="item in classification"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="jump_url" class="formItemFill" label="跳转地址">
            <el-input v-model="formValue.jump_url" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
         <el-form-item prop="is_enable" class="formItemFill" label="是否启用" >
            <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
         <el-form-item prop="is_home_recommended" class="formItemFill" label="是否推荐" >
            <el-radio-group v-model="formValue.is_home_recommended" size="small" style="width: 100%">
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
       <el-col :span="12">
         <el-form-item prop="seo_title" class="formItemFill" label="SEO标题">
           <el-input v-model="formValue.seo_title" size="small" autocomplete="off"></el-input>
         </el-form-item>
       </el-col>
       <el-col :span="12">
         <el-form-item prop="seo_keywords" class="formItemFill" label="SEO关键字">
           <el-input v-model="formValue.seo_keywords" size="small" autocomplete="off"></el-input>
         </el-form-item>
       </el-col>
      </el-row>
      <el-row>
       <el-col :span="24">
         <el-form-item prop="seo_desc" class="formItemFill" label="SEO描述">
           <el-input v-model="formValue.seo_desc" size="small" autocomplete="off"></el-input>
         </el-form-item>
       </el-col>
      </el-row>
    </el-form>
        <vue-ueditor-wrap v-model="formValue.content" :config="myConfig"></vue-ueditor-wrap>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { ArticleService } from '../../service/article.service';
import VueUeditorWrap from 'vue-ueditor-wrap'

  export default {
    name: 'formCustomPage',
    components: { VueUeditorWrap  },
    data() {
      return {
        myConfig: {
      // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        //serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=article',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ue/'
        },
        visible: false,
        openType: '',
        formValue: { },
        checkAll: false,
        classification:[],
        rules: {
          title: [{ required: true, message: '标题不能为空'}],
          article_category_id: [{ required: true, message: '请选择文章分类', trigger: 'check' }],
          jump_url: [{ required: true, message: '跳转地址不能为空'}],
        },
      }
    },
    methods: {
      async open(type, data, classification) {
        this.classification = classification
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && data) {
          const result = JSON.parse(JSON.stringify(await ArticleService.getArticleDetail(data.id)))
          this.formValue = result
        }
        this.openType === type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: 1,
          is_home_recommended: 1,
          sort: 50,
          title_color: '#333'
        };
      },
      async submit() {
          const result = await this.$refs.form.validate();
          if(result)
          await ArticleService.submitArticle(this.formValue);
          this.$emit('submitSuccess')
          this.close();
      },
      close() {
        this.visible = false;
        this.formValue = {};
      }
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<style lang="scss">
  .article{
    .title_color.formItemFill{
      height: 4.7vw;
      .el-color-picker__trigger{
        width: 100%;
        margin-top: -0.7vw;
        .el-color-picker__icon{
          display: none;
        }
      }
    }
    .el-dialog__header{
      position: fixed;
      width: calc(100% - 200px);
      z-index: 9999;
    }
    .el-dialog__body{
      margin-top: 65px
    }
  }
</style>